import { ContactSalesModal } from './ContactSalesModal/ContactSalesModal'
import { FC, useEffect } from 'react'
import { PaymentModal } from './PaymentModal/PaymentModal'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useLockedFeatureModal } from './hooks/useLockedFeatureModal'

const contactUsPlanTypes = [PlanType.PRO_FLEX, PlanType.ENTERPRISE]
const onlyContactUsPlanTypes = [PlanType.PRO_FLEX, PlanType.ENTERPRISE] as const
export type ContactUsPlanType = (typeof onlyContactUsPlanTypes)[number]
const payUsPlanTypes = [PlanType.PRO, PlanType.PRO_PLUS_ORG]

export const LockedFeatureModal: FC = () => {
  const { open, onClose, lockContent, lockedFeatureName, lockedFeaturePlanType } =
    useLockedFeatureModal()

  const shouldBeOpen = open && lockedFeatureName && lockedFeaturePlanType
  const showPaymentModal = shouldBeOpen && payUsPlanTypes.includes(lockedFeaturePlanType)
  const showContactUsModal = shouldBeOpen && contactUsPlanTypes.includes(lockedFeaturePlanType)

  useEffect(() => {
    if (open) {
      fireAnalyticsEvent('locked_feature_modal_open', {
        value: lockedFeatureName,
        planType: lockedFeaturePlanType
      })
    }
  }, [open, lockedFeatureName, lockedFeaturePlanType])
  return (
    <>
      {showPaymentModal && (
        <PaymentModal
          open={open}
          onClose={onClose}
          lockPlanType={lockedFeaturePlanType}
          lockContent={lockContent}
        />
      )}
      {showContactUsModal && (
        <ContactSalesModal
          open={open}
          onClose={onClose}
          lockPlanType={lockedFeaturePlanType as ContactUsPlanType}
          lockContent={lockContent}
        />
      )}
    </>
  )
}
